import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import entryPoint from './automationLimits.entrypoint';
import { FREE_DIALOG_CONFIG } from './dialog-config';

export function AutomationFreeLimitModal(): React.JSX.Element {
	const { edition } = useEditionAwareness();

	const DIALOG_CONFIG = useMemo(() => {
		if (edition === 'free') {
			return FREE_DIALOG_CONFIG;
		}
		throw new Error(`Unsupported edition: ${edition}`);
	}, [edition]);

	const modalProps = useMemo(() => ({ width: 968, height: 516 }), []);

	return (
		<ModalEntryPoint modalProps={modalProps} entryPoint={entryPoint} dialogConfig={DIALOG_CONFIG} />
	);
}
